import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Email Batch V2!", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "card-body overflow-auto",
  style: {"white-space":"nowrap"}
}
const _hoisted_6 = {
  class: "table align-middle fs-6 gy-5",
  id: "kt_ecommerce_add_product_reviews"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "id", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "Batch ID", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Tenants", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Total / Sent / Fail", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Status", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_16 = { class: "d-flex align-items-center gap-2" }

import { onMounted, ref } from "vue";
import moment from "moment";
import TopicService from "../services/TopicService";
import { TenantOptions } from "@/core/types/TenantTypes";
import CreateAndEditBatch from "../components/sendEmailBatchV2/CreateAndEditBatch.vue";
import notification from "@/core/plugins/notification";
import SendTestEmailDialog from "../components/sendEmailBatchV2/SendTestEmailDialog.vue";
import FailEmailList from "../components/sendEmailBatchV2/FailEmailList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendEmailBatchV2',
  setup(__props) {

const data = ref(Array<any>());
const isLoading = ref(true);
const createBatchRef = ref<any>(null);
const sendTestEmailDialogRef = ref<any>(null);
const failEmailListRef = ref<any>(null);
const sendLoading = ref(false);
const sendCriteria = ref<any>({
  batchId: "",
  tenantIds: [],
  noDuplicate: false,
  emailList: [],
  effectiveFrom: null,
});

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await TopicService.queryEmailBatchList();
    data.value = res.map((x) => {
      x.isLoading = false;
      return x;
    });
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const singleRefresh = async (item) => {
  item.isLoading = true;
  try {
    const res = await TopicService.queryEmailBatchList();
    const target = res.find((x) => x.id === item.id);
    if (target) {
      data.value[data.value.findIndex((x) => x.id === item.id)] = target;
    }
  } catch (e) {
    console.log(e);
  } finally {
    item.isLoading = false;
  }
};

const sendBatch = async (item) => {
  sendLoading.value = true;
  try {
    await sendCriteriaSetup(item);
    console.log(sendCriteria.value);
    await TopicService.sendEmailBatchV2(sendCriteria.value);
    notification.success();
    await fetchData();
  } catch (e) {
    console.log(e);
  } finally {
    sendLoading.value = false;
  }
};

const sendCriteriaSetup = async (item) => {
  sendCriteria.value.noDuplicate = getBatchObj(
    item.additionalInformation
  ).noDuplicate;
  sendCriteria.value.batchId = getBatchObj(item.additionalInformation).batchId;
  sendCriteria.value.tenantIds = getBatchObj(
    item.additionalInformation
  ).tenantIds;
  sendCriteria.value.emailList = getBatchObj(
    item.additionalInformation
  ).emailList;
  sendCriteria.value.effectiveFrom = null;
};

const getBatchObj = (info: string) => {
  try {
    if (!info) return {};
    return JSON.parse(info);
  } catch (e) {
    return {};
  }
};

// 是否为定时发送（以 scheduleSend 为准）
const isScheduled = (item: any) =>
  Boolean(item.scheduleSend) && Boolean(item.effectiveFrom);

// effectiveFrom 存的是 UTC（无 Z），转成本地时间的 ISO 给 TimeShow 用
const effectiveFromLocal = (item: any) =>
  item.effectiveFrom
    ? moment.utc(item.effectiveFrom).local().format("YYYY-MM-DDTHH:mm:ss")
    : null;

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "success",
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createBatchRef.value?.show())),
          disabled: isLoading.value || sendLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.new")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData())),
          loading: isLoading.value || sendLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.title")), 1),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: _normalizeClass({ 'bg-light': item.isLoading })
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(getBatchObj(item.additionalInformation).batchId), 1),
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getBatchObj(item.additionalInformation)
                  .tenantIds, (tenantId) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          class: "me-1",
                          key: tenantId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(TenantOptions).find((x) => x.value === parseInt(tenantId))
                    ?.label), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.total) + " / " + _toDisplayString(item.sent) + " / " + _toDisplayString(item.failed), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_tag, {
                        type: 
                  item.batchCreated
                    ? 'success'
                    : isScheduled(item)
                    ? 'primary'
                    : 'warning'
                
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.batchCreated
                    ? "Sent"
                    : isScheduled(item)
                    ? "Scheduled"
                    : "Ready"), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": 
                  isScheduled(item) ? effectiveFromLocal(item) : item.createdOn
                
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_16, [
                        (!item.batchCreated)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                plain: "",
                                disabled: isLoading.value || sendLoading.value,
                                onClick: ($event: any) => (createBatchRef.value?.show(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]),
                              _createVNode(_component_el_button, {
                                type: "info",
                                plain: "",
                                disabled: isLoading.value || sendLoading.value,
                                onClick: ($event: any) => (sendTestEmailDialogRef.value?.show(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Send Test Email ")
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"]),
                              _createVNode(_component_el_popconfirm, {
                                class: "box-item",
                                title: "Confirm to send emails?",
                                placement: "top-start",
                                onConfirm: ($event: any) => (sendBatch(item))
                              }, {
                                reference: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "warning",
                                    plain: "",
                                    loading: isLoading.value || sendLoading.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Sent Emails")
                                    ]),
                                    _: 1
                                  }, 8, ["loading"])
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                plain: "",
                                onClick: ($event: any) => (singleRefresh(item)),
                                loading: isLoading.value || sendLoading.value || item.isLoading
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "loading"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                plain: "",
                                onClick: ($event: any) => (failEmailListRef.value?.show(item.failedEmailList))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" View Failed ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 64)),
                        _createVNode(_component_el_button, {
                          type: "success",
                          plain: "",
                          disabled: isLoading.value || sendLoading.value,
                          onClick: ($event: any) => (createBatchRef.value?.duplicate(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Duplicate ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ])
                    ])
                  ], 2))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(CreateAndEditBatch, {
      ref_key: "createBatchRef",
      ref: createBatchRef,
      onRefresh: fetchData
    }, null, 512),
    _createVNode(SendTestEmailDialog, {
      ref_key: "sendTestEmailDialogRef",
      ref: sendTestEmailDialogRef
    }, null, 512),
    _createVNode(FailEmailList, {
      ref_key: "failEmailListRef",
      ref: failEmailListRef
    }, null, 512)
  ]))
}
}

})